import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { SidebarComponent } from './sidebar.component';

angular.module('app-lite.sidebar', [])
  .directive('worSidebar', downgradeComponent({ component : SidebarComponent }) as ng.IDirectiveFactory);
